import React, { useEffect, useRef, useState } from "react";
import {
  Link,
  NavLink,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { HiDatabase } from "react-icons/hi";
import { MdAccountBox } from "react-icons/md";
import { AiFillFileAdd } from "react-icons/ai";
import { AiFillFileText } from "react-icons/ai";
import "./style.css";
import ArrowIcon from "../../../assets/steps-arrow.png";
import { useSelector } from "react-redux";
import Fontstyling from "../../../components/common/comman";
import UtilityData from "../UtilityData";
import ClientData from "../Clientdata";
import ImportCensus from "../ImportCensus";
import ReportExport from "../Report&Extract";
import { Icon } from "@iconify/react/dist/iconify";
import theme from "../../../Utils/theme";
import AdminPrivateRoute from "../../../components/common/AdminPrivateRoute";

const Dashboard = ({ navigate }) => {
  const [show, setShow] = useState(false);
  const scrollToTopRef = useRef();
  const { UD_emp_name, UserRole } = useSelector(
    (state) => state.userDetails.value
  );
  const location = useLocation();

  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    scrollToTopRef.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  return (
    <>
      {" "}
      {/* <div className="w-60 text-center">
        <ul className="d-flex justify-content-center list-unstyled acglayout">
          {UserRole === "Admin" ? (
            <>
              <li>
                <NavLink
                  to={"/ACGHealthInsights/utilitydata"}
                  style={({ isActive }) => ({
                    color: isActive
                      ? theme.SECONDARY_SHOCKING_BLUE
                      : theme.SECONDARY_CLASSIC_DARK,
                  })}
                >
                  <span>
                    <Icon icon={"mdi:database"} width={30} height={34} />
                  </span>
                  <div>Utility Data</div>
                </NavLink>
              </li>
              <li>
                <img src={ArrowIcon} />
              </li>
            </>
          ) : (
            <></>
          )}

          {/* <li>
            <NavLink
              to={"/ACGHealthInsights/utilitydata"}
              style={({ isActive }) => ({
                color: isActive
                  ? theme.SECONDARY_SHOCKING_BLUE
                  : theme.SECONDARY_CLASSIC_DARK,
              })}
            >
              <span>
                <Icon icon={"mdi:database"} width={30} height={34} />
              </span>
              <div>Utility Data</div>
            </NavLink>
          </li>
          <li>
            <img src={ArrowIcon} />
          </li> 

          <li>
            <NavLink
              to={"/ACGHealthInsights/clientdata"}
              style={({ isActive }) => ({
                color: isActive
                  ? theme.SECONDARY_SHOCKING_BLUE
                  : theme.SECONDARY_CLASSIC_DARK,
              })}
            >
              <span>
                <Icon icon="mdi:account" width={30} height={34} />
              </span>
              <div>Client Data</div>
            </NavLink>
          </li>
          {/* <li>
            <img src={ArrowIcon} />
          </li> */}
      {/* <li>
            <NavLink
              to={"/ACGHealthInsights/importcensus"}
              style={({ isActive }) => ({
                color: isActive
                  ? theme.SECONDARY_SHOCKING_BLUE
                  : theme.SECONDARY_CLASSIC_DARK,
              })}
            >
              <span>
                <Icon icon="mdi:file-import" width={30} height={34} />
              </span>
              <div>Import Census</div>
            </NavLink>
          </li>
          <li>
            <img src={ArrowIcon} />
          </li>
          <li>
            <NavLink
              to={"/ACGHealthInsights/report&extract"}
              style={({ isActive }) => ({
                color: isActive
                  ? theme.SECONDARY_SHOCKING_BLUE
                  : theme.SECONDARY_CLASSIC_DARK,
              })}
            >
              <span>
                <Icon icon="mdi:file-document" width={30} height={34} />
              </span>
              <div>Report & Extract</div>
            </NavLink>
          </li>
        </ul>
      </div> */}
      <div className="m-0" ref={scrollToTopRef}>
        <Routes>
          <Route
            index
            element={
              <div className="m-auto w-75">
                {" "}
                <h2>
                  Welcome
                  <small style={{ color: "#9c9fa6" }}> {UD_emp_name},</small>
                </h2>
                <p
                  className="mt-3 font-weight-light"
                  style={Fontstyling.primaryparagraph}
                >
                  You are successfully logged into ACG Health Insights. Now
                  that you are logged in, please take a moment to review the
                  user guide provided to you. This user guide will assist you in
                  using the system properly and ensure that you are able to
                  generate the necessary reports for the PowerBI template and/or
                  for your client and prospect strategy meeting. If you have any
                  issues with the system, including setting up a new client,
                  downloading reports or uploading templates, please contact a
                  member of the team at{" "}
                  <Link
                    className="text-secondary"
                    to="mailto:Kryz.Novotnaj@hubinternational.com"
                  >
                    acghelp@AHI.com
                  </Link>
                  .
                </p>
              </div>
            }
          />
          <Route
            path="/utilitydata/*"
            element={
              <AdminPrivateRoute>
                <UtilityData navigate={navigate} />
              </AdminPrivateRoute>
            }
          />
          <Route
            path="/clientdata/*"
            element={<ClientData navigate={navigate} />}
          />
          <Route
            path="/importcensus/*"
            element={<ImportCensus navigate={navigate} />}
          />
          <Route
            path="/report&extract/*"
            element={<ReportExport navigate={navigate} />}
          />
        </Routes>
      </div>
    </>
  );
};

export default Dashboard;
